// import videojs from 'video.js';
// class VideoPlayer {
//   constructor() {
//     this.targets = document.querySelectorAll('.js-video-player')

//     this.modes = ['fill', 'contain', 'cover', 'none'];
//     this.haligns = {'left': 0, 'center': 2, 'right' : 1};
//     this.valigns = {'top': 0, 'middle': 2, 'bottom' : 1};

//   }

//   init() {
//     this.fixed();
//     this.attachEvent();
//   }

//   fixed() {
//     for (const target of this.targets) {
//       let video = target.querySelector('.js-video-player-content')
//       let wrapperWidth = target.clientWidth
//       let wrapperHeight = target.clientHeight
//       let videoWidth = video.clientWidth
//       let videoHeight = video.clientHeight
//       let wRatio = wrapperWidth / videoWidth
//       let hRatio = wrapperHeight / videoHeight

//       let useRatio = Math.max(wRatio, hRatio)




//       // let videoWidth2 = flag ? `${useSize * useRatio}px` : `${useSize}px`
//       // let videoHeight2 = flag ? `${useSize}px` : `${useSize * useRatio}px`

//       console.log("wRatio:" + wrapperWidth / videoWidth)
//       console.log("hRatio:" + wrapperHeight / videoHeight)
//       console.log("w:"+wrapperWidth)
//       console.log("h:"+wrapperHeight)
//       console.log("vw:"+videoWidth)
//       console.log("vh:"+videoHeight)

//       const styles = [
//         ['position', 'absolute'],
//         ['width', `${videoWidth * useRatio}px`],
//         ['height', `${videoHeight * useRatio}px`],
//         ['left', `${(wrapperWidth / 2) - (videoWidth * useRatio / 2)}px`],
//         ['top', `${(wrapperHeight / 2) - (videoHeight * useRatio / 2)}px`]
//       ]

//       for (const [key, value] of styles) {
//         video.style[key] = value;
//       }


//     }
//   }

//   calculateRatio(target) {
//     const wrapper = target
//     const video = target.querySelector('.js-video-player-content')

//     const mode = "cover"

//     let ratio = {
//       wRatio : wRatio,
//       hRatio : hRatio
//     }

//     let wRatio = wrapper.clientWidth / video.clientWidth
//     let hRatio = wrapper.clientHeight / video.clientHeight

//     if(mode == 'cover'){
//       ratio.wRatio = Math.max(wRatio, hRatio);
//       ratio.hRatio = Math.max(wRatio, hRatio);
//     }

//     return ratio

//   }


//   attachEvent() {
//     window.addEventListener('resize', () => {
//       this.fixed();
//     })
//   }

// }



// // preventEvent(video22, "seeking", function (el) { return });
// // preventEvent(video22, "seeked", function (el) { return });
// function preventEvent(element, eventName, test) {
//   function handler(e) {
//     if (!test || test(element, eventName)) {
//       e.stopImmediatePropagation();
//     }
//   }
//   element.addEventListener(eventName, handler);
//   return handler;
// }